import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MaterialModule } from '../../../core/shared/material.module';

@Component({
  selector: 'app-dropdown-with-sections',
  standalone: true,
  imports: [CommonModule, MatIconModule, MaterialModule],
  templateUrl: './dropdown-with-sections.component.html',
  styleUrl: './dropdown-with-sections.component.scss'
})
export class DropdownWithSectionsComponent implements OnInit, OnChanges{
  @Input()
  config? : { 
    placeholderText?: string,
    placeholderIcon?: string,
    styles?: any,
    iconType: 'mat-icon' | 'assetImage'
  } = { 
    iconType: 'mat-icon'
  };

  @Input()
  customStyle: any = {};

  @Input()
  fields: any[] = [];

  @Input()
  selectedValue: any;

  @Output() onSelect = new EventEmitter();

  selectedOption: any = null;
  dropdownOpen: boolean = false;

  ngOnInit(): void {
    if(this.selectedValue) this.initializeSelectedItem();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['selectedValue'] || changes['fields']) && this.selectedValue) {
      this.initializeSelectedItem();
    }
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  selectOption(option: any):void {
    this.selectedOption = option;
    this.onSelect.emit(option);
    this.toggleDropdown();
  }

  initializeSelectedItem() {
    this.fields.forEach((section: any) => {
      let item = section.options?.find((option: any) => option.value === this.selectedValue);
      if(item) this.selectedOption = item;
    });
  }
}
